import {gql} from '@apollo/client';

const UPDATE_BUS_PARTNER_BUS_COST_ENTRY_V2 = gql`
  mutation updateBusPartnerBusCostEntryV2(
    $busPartnerId: ID!
    $year: Int!
    $adblueCost: FuelCost
    $cleaningCost: Float
    $dieselCost: FuelCost
    $legalCost: Float
    $lngCost: Float
    $otherCost: Float
    $overheadCost: Float
    $repairCostPerDistanceUnit: CostPerDistance
    $repairCostPerMonth: Float
    $tiresCost: TiresCost
  ) {
    updateBusPartnerBusCostEntryV2(
      input: {
        busPartnerId: $busPartnerId
        year: $year
        adblueCost: $adblueCost
        cleaningCost: $cleaningCost
        dieselCost: $dieselCost
        legalCost: $legalCost
        lngCost: $lngCost
        otherCost: $otherCost
        overheadCost: $overheadCost
        repairCostPerDistanceUnit: $repairCostPerDistanceUnit
        repairCostPerMonth: $repairCostPerMonth
        tiresCost: $tiresCost
      }
    ) {
      adblueCost
      cleaningCost
      currency
      dieselCost
      legalCost
      lngCost
      otherCost
      overheadCost
      repairCostPerDistanceUnit
      repairCostPerMonth
      tiresCost
      year
    }
  }
`;

export default UPDATE_BUS_PARTNER_BUS_COST_ENTRY_V2;
